export default function BrandStorySection() {
  return (
    <section className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-5xl mx-auto">
          <div className="bg-stone-50 rounded-3xl overflow-hidden shadow-2xl">
            <div className="grid grid-cols-1 lg:grid-cols-2">
              <div className="relative h-[500px] lg:h-auto">
                <img
                  src="https://static.readdy.ai/image/d1a0c06a8edb29d2039b650faf22b9bc/68cabb9926e01345de441d319958abfb.jpeg"
                  alt="re:day 브랜드"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              
              <div className="p-12 lg:p-16 flex flex-col justify-center">
                <h2 className="text-7xl font-bold text-gray-800 mb-8" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                  re:day
                </h2>
                
                <p className="text-xl text-gray-700 mb-12 leading-relaxed">
                  버려지는 자원을 다시 디자인하고
                  <br />
                  더 오래 사용할 수 있는 옷을 만듭니다
                </p>
                
                <div className="space-y-6 mb-14">
                  <div className="flex items-start gap-5">
                    <div className="w-3 h-3 bg-emerald-600 rounded-full mt-2 flex-shrink-0"></div>
                    <div>
                      <h3 className="text-2xl font-semibold text-gray-800 mb-2" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                        Recycle
                      </h3>
                      <p className="text-base text-gray-600">
                        버려지는 자원을 수거하고 분류합니다
                      </p>
                    </div>
                  </div>
                  
                  <div className="flex items-start gap-5">
                    <div className="w-3 h-3 bg-emerald-600 rounded-full mt-2 flex-shrink-0"></div>
                    <div>
                      <h3 className="text-2xl font-semibold text-gray-800 mb-2" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                        Redesign
                      </h3>
                      <p className="text-base text-gray-600">
                        새로운 디자인으로 재탄생시킵니다
                      </p>
                    </div>
                  </div>
                  
                  <div className="flex items-start gap-5">
                    <div className="w-3 h-3 bg-emerald-600 rounded-full mt-2 flex-shrink-0"></div>
                    <div>
                      <h3 className="text-2xl font-semibold text-gray-800 mb-2" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                        Rebirth
                      </h3>
                      <p className="text-base text-gray-600">
                        더 오래 사용할 수 있는 제품으로 완성합니다
                      </p>
                    </div>
                  </div>
                </div>

                <a 
                  href="https://reday.kr" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="px-10 py-4 bg-emerald-600 text-white text-base font-medium rounded-xl hover:bg-emerald-700 transition-all duration-300 whitespace-nowrap cursor-pointer w-fit shadow-lg hover:shadow-xl"
                >
                  브랜드 사이트 보기
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}